import { render } from "./FileDetailsModal.vue?vue&type=template&id=5a1150a0"
import script from "./FileDetailsModal.vue?vue&type=script&lang=js"
export * from "./FileDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__